import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

import getAllUsersInNetwork, { GetAllUsersInNetworkInput, GetAllUsersInNetworkOutput } from '.';

type TrimmedGetAllUsersInNetworkInput = Omit<GetAllUsersInNetworkInput, 'dlVaultContract'>;

export type UseGetAllUsersInNetworkQueryKey = [
  FunctionKey.GET_ALL_USERS_IN_NETWORK,
  TrimmedGetAllUsersInNetworkInput,
];

type Options = QueryObserverOptions<
  GetAllUsersInNetworkOutput,
  Error,
  GetAllUsersInNetworkOutput,
  GetAllUsersInNetworkOutput,
  UseGetAllUsersInNetworkQueryKey
>;

const useGetAllUsersInNetwork = (input: TrimmedGetAllUsersInNetworkInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_ALL_USERS_IN_NETWORK, input],
    () => getAllUsersInNetwork({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetAllUsersInNetwork; 